import { Component, Input } from '@angular/core';
import { AppRoute } from 'src/app/app-routing.module';
import { UserRole } from 'src/app/core/enums/user/user-role.enum';
import { UserProfile } from 'src/app/core/models/user/user-profile.model';

@Component({
    selector: 'sidenav-content-user-navigation',
    templateUrl: './sidenav-content-user-navigation.component.html',
    styleUrls: ['./sidenav-content-user-navigation.component.scss'],
    standalone: false
})
export class SidenavContentUserNavigationComponent {

  @Input() user: UserProfile | undefined | null

  userRole = UserRole
  appRoute = AppRoute


}
